module.exports = __webpack_public_path__ + "static/skyward-atlas-8bb62a2d4f6e1ed8dbbafe0a5281d992.png";